import Date from "./KrDate.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrDate = install(Date); // 生成带有 install 方法的组件

export default KrDate;
